import React, { useState, useEffect } from "react";

import { getUser, getIdToken } from "../../../utils/storage";
import { fetchTotalSurveys } from "../../../services/dashboard-api";

// Tune these to taste
const SHOW_PROBABILITY = 0.15; // 15% chance on any given login after the first
const MIN_DAYS_BETWEEN_SHOWS = 7; // don't nag more than once a week

const getTooltipStorageKey = (uid) => `surveysTooltip_${uid}`;

const shouldShowTooltip = (uid) => {
  const key = getTooltipStorageKey(uid);
  const raw = localStorage.getItem(key);

  // First time ever for this user -> always show
  if (!raw) {
    return true;
  }

  const { lastShown } = JSON.parse(raw);
  const daysSinceLastShown = (Date.now() - lastShown) / (1000 * 60 * 60 * 24);

  if (daysSinceLastShown < MIN_DAYS_BETWEEN_SHOWS) {
    return false;
  }

  return Math.random() < SHOW_PROBABILITY;
};

const markTooltipShown = (uid) => {
  localStorage.setItem(
    getTooltipStorageKey(uid),
    JSON.stringify({ lastShown: Date.now() })
  );
};

const SurveysTotal = (props) => {
  const { client, setToast, tooltip, setTooltip } = props;

  const user = getUser(),
    idToken = getIdToken();

  const uid = user?.user?.id;

  const [totalSurveys, setTotalSurveys] = useState(0);
  const [showAskTooltip, setShowAskTooltip] = useState(false);

  // Decide once per login whether to show the tooltip
  useEffect(() => {
    if (!uid) return;

    const shouldShow = shouldShowTooltip(uid);
    setShowAskTooltip(shouldShow);

    if (shouldShow) {
      markTooltipShown(uid);
    }
  }, [uid]);

  const dismissTooltip = () => {
    setShowAskTooltip(false);
  };

  useEffect(() => {
    if (!client?.clientRef) return;

    const getTotalSurveys = async () => {
      try {
        const { data } = await fetchTotalSurveys(client.clientRef);
        const total = data?.totalSurveys ?? 0;
        setTotalSurveys(total);
      } catch (error) {
        console.log("Error obtaining total surveys", error.message);
        setToast({
          show: true,
          type: "warning",
          message: "We had problems retrieving total surveys. Please refresh",
        });
      }
    };

    getTotalSurveys();
  }, [client?.clientRef]);

  return (
    <div className="card-section horizontal padded expand">
      <div className="data huge">{totalSurveys}</div>
      <h3 className="move-down">Surveys</h3>
      <div
        style={{
          display: tooltip.step === 1 && showAskTooltip ? "flex" : "none",
          width: "300px",
        }}
        className=" inline-tooltip-content top"
      >
        {/* step 1 tool tip */}
        <div className="card-section">
          <div>Surveys</div>
          <p className="move-down">
            This is the total number of surveys you have on your dashboard
          </p>

          <div className="inline-tooltip-frame">
            <span
              onClick={() => {
                setTooltip({
                  show: false,
                  type: "",
                  title: "",
                  message: "",
                  step: 0,
                  max_step: 5,
                });
                dismissTooltip();
              }}
            >
              Skip tutorial
            </span>
            <button
              className="inline-tooltip-button"
              onClick={() => {
                setTooltip({
                  show: true,
                  type: "",
                  title: "",
                  message: "",
                  step: 2,
                  max_step: 5,
                });
                dismissTooltip();
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveysTotal;
